import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=213d9544&"
import script from "./ActivityHistory.vue?vue&type=script&lang=ts&"
export * from "./ActivityHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports